// ✅ ExperienceInput.jsx
import React, { useState } from "react";

const ExperienceInput = ({ onExperienceChange }) => {
  const [years, setYears] = useState("");
  const [technologies, setTechnologies] = useState("");
  const [domain, setDomain] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onExperienceChange({ years, technologies, domain }); // ✅ FIXED
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-xl font-bold mb-4">Enter Your Experience</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Years of Experience:</label>
          <input
            type="number"
            className="border p-2 rounded w-full"
            value={years}
            onChange={(e) => setYears(e.target.value)}
            min={0}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Key Technologies Used:</label>
          <input
            type="text"
            className="border p-2 rounded w-full"
            value={technologies}
            onChange={(e) => setTechnologies(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Domain Expertise:</label>
          <input
            type="text"
            className="border p-2 rounded w-full"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="px-4 py-2 bg-green-600 text-white rounded"
        >
          Submit Experience
        </button>
      </form>
    </div>
  );
};

export default ExperienceInput;
